import { IntlAccountHelper, getQuery, isMobile } from '@tencent/pa-cms-utils';
import { clearLoginCookie, getLoginCookie, setLoginCookie } from "./cookie";
import { isInIntlBrowser, getLang, urlparamsToObject } from "./tools";
import { INTL_ENV, game_id, INTL_HOST, ACCOUNT_APP_ID, ACCOUNT_PLAT_TYPE, hostINTL, hostThird } from "./const";

export type INTL_THIRD_TYPE =
  | 'apple'
  | 'facebook'
  | 'twitter'
  | 'google'
  | 'line';
interface ThirdLoginParams{
  channel: INTL_THIRD_TYPE
}
interface LiPassLoginParams{
  email: string;
  password: string
}
export const channel_map = {
  google: "6",
  facebook: "4",
  apple: "15",
  line: "14",
  twitter: "9",
  email: "131",
};

export const intl_account_helper = new IntlAccountHelper({
  area_id: INTL_ENV,
  game_id: game_id,
  extra_config: {
    langType: getLang(),
    appID: ACCOUNT_APP_ID,
    hostCAcc: INTL_HOST,
    accountPlatType: ACCOUNT_PLAT_TYPE,
    hostINTL,
    hostThird,
  },
});
/**
 * 检查登录
 * @description encodeparam 为游戏内打开时从注入的登录态
 */
export function checkLogin() {
  const data = getLoginCookie();
  const { openid, token, encodeparam } = data;
  return (!!openid && !!token) || (Boolean(encodeparam) && isInIntlBrowser);
}

async function init() {
  const channel = getQuery("channelid");
  if (getQuery("encodeparam") ) {
    const url_obj = urlparamsToObject();
    setLoginCookie(
      Object.assign({}, url_obj, {
        channel: channel,
        game_id: url_obj.gameid,
        expires: url_obj.ts + 60 * 60 * 24 * 30 * 1000,
        // 角色验证相关
        zone_id: url_obj.partition,
        lang_type: url_obj.sLanguage,
        area_id: url_obj.area,
        role_id: url_obj.roleid,
        // role_name: url_obj.user_name,
      })
    );
    return;
  }
  await line_login();
}
async function line_login(){
  try {
    const url_login_params = await intl_account_helper.loginByUrlCode();
    console.log('line_login', url_login_params)
    const channel = getQuery('msgType');
    if (!url_login_params || url_login_params.ret !== 0 || !channel) return;
    setLoginCookie(combieLOginCookie(url_login_params, channel));
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('operate_type');
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState(null, '', newUrl);
    return;
  } catch (err) {
    console.log('err', err)
    return;
  }
}
const info = () => {
  const data = getLoginCookie();
  return data;
};
const login = async (params: ThirdLoginParams | LiPassLoginParams) => {
  if (checkLogin()) {
    return info();
  }
  function isThirdLoginParams(data: unknown): data is ThirdLoginParams {
    return typeof data === "object" && data !== null && "channel" in data;
  }
  let res;
  if (isThirdLoginParams(params)) {
    res = await thirdLogin(params);
  } else {
    res = await liPassLogin(params);
  }
  if (!res){ 
    setLoginCookie(res);
  }
};

function combieLOginCookie(loginInfo: Record<string, any>, channel: string) {
  const { token_expire_time, ts = (new Date()).getTime() } = loginInfo;
  return Object.assign({}, loginInfo, {
    game_id: game_id,
    channel: channel_map[channel as keyof typeof channel_map],
    expires: ((token_expire_time as number) * 1000) || ((ts as number) + 60 * 60 * 24 * 30 * 1000) ,
  })
}
export async function thirdLogin(params: ThirdLoginParams) {
  console.log('thirdLogin', params)
  const { channel } = params;
  let login_params: any = {
    third_type: channel,
  };
  console.log('login_params', login_params)
  const login_res: any = await intl_account_helper.thirdLogin(login_params);
  console.log('login_res', login_res)
  if (!login_res || login_res.ret !== 0) {
    throw Error();
  }
  setLoginCookie(combieLOginCookie(login_res, channel));
  return login_res;
}

export async function liPassLogin(params: LiPassLoginParams) {
  const { email, password } = params;
  const intl_account_plat = 131;
  const jssdk = await intl_account_helper.getAccountApi();
  const li_res = await jssdk.signIn({
    account_type: 1,
    account: email,
    password: password,
  });
  console.log('li_res', li_res)
  const login_res = await jssdk.intlSignIn({
    account: email,
    account_type: 1,
    token: li_res.token,
    openid: li_res.uid,
    account_plat_type: intl_account_plat,
  });
  console.log('login_res', login_res)
  if (!login_res || login_res.ret !== 0) {
    throw Error(login_res.ret);
  }
  setLoginCookie(combieLOginCookie(login_res, "email"));
  return login_res;
}

const showLogin = async (loginParam?: Record<string, any>) => {
  clearLoginCookie()
  return false;
};

const logout = async () => {
  clearLoginCookie()
  return;
};
export default {
  checkLogin,
  login,
  info,
  showLogin,
  logout,
  init,
  isMobile
};
